import { useState, type FormEvent, type ReactNode } from 'react';
import { Navigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function LoginPage(): ReactNode {
  const auth = useAuth();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const requested = (location.state as { returnTo?: unknown } | null)?.returnTo;
  const returnTo = typeof requested === 'string' && requested.startsWith('/') && !requested.startsWith('//')
    ? requested
    : '/pipeline';
  if (auth.session) return <Navigate to={returnTo} replace />;
  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await auth.signIn(email, password);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Не удалось войти');
    } finally {
      setBusy(false);
    }
  }
  return (
    <main className="auth-page">
      <section className="auth-card" aria-labelledby="login-title">
        <div className="auth-brand">Echo</div>
        <h1 id="login-title">Вход в Echo CRM</h1>
        <p>Продажи, компании и задачи — в одном рабочем пространстве.</p>
        <form onSubmit={submit}>
          <label>Email<input type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></label>
          <label>Пароль<input type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label>
          {error ? <div className="form-error" role="alert">{error}</div> : null}
          <button className="button button-primary" disabled={busy}>{busy ? 'Входим…' : 'Войти'}</button>
        </form>
        <Link to="/reset-password">Восстановить пароль</Link>
      </section>
    </main>
  );
}
